import React, { useRef } from "react";
import { ModalApi } from "components/modal/Modal";
import Button, { ButtonLevel } from "components/ui/Button";
import AprilModal from "components/modal/AprilModal";
import FormContentLayout from "components/layout/FormContentLayout";
import useTaxReturnsWithAdvance from "utils/hooks/useTaxReturnsWithAdvance";

const TaxFilingRejected: React.FC = () => {
  const aprilModal = useRef<ModalApi>(null);
  useTaxReturnsWithAdvance({
    pollingInterval: 2000,
  });

  return (
    <>
      <FormContentLayout
        heading="There was an issue submitting your tax returns."
        subheading='Please click "Continue" below for details.'
        actions={
          <Button
            fullWidth
            level={ButtonLevel.cta}
            onClick={() => aprilModal.current.show()}
          >
            Continue
          </Button>
        }
      />

      <AprilModal ref={aprilModal} />
    </>
  );
};

export default TaxFilingRejected;
